import React from "react";
import SEO from "../components/SEO";

const DigitalMarketingSEO = () => {
  return (
    <>
      <SEO
        title="Digital Marketing & SEO Services for Startups"
        description="Boost your online presence with 100 Eyes Technologies' digital marketing and SEO services. Get your startup or small business noticed on Google and attract more customers effectively."
        keywords="Digital marketing India, SEO services, startup marketing solutions, online visibility, SME marketing, 100 Eyes Technologies"
      />

      <main className="container py-5">
        <h1 className="mb-4 text-center">Digital Marketing & SEO</h1>

        <section className="mb-5">
          <p>
            At <strong>100 Eyes Technologies</strong>, we provide comprehensive <strong>digital marketing and SEO services</strong> to help startups and SMEs establish a strong online presence. In today’s competitive digital landscape, having a website alone is not enough; businesses need effective strategies to attract, engage, and convert customers online.
          </p>
          <p>
            Our team specializes in creating targeted marketing campaigns, search engine optimization, social media management, and content strategies that drive traffic and generate leads. By leveraging the latest digital marketing techniques, we help your business achieve measurable growth and maximize ROI.
          </p>
        </section>

        <section className="mb-5">
          <h2 className="mb-3">Why Digital Marketing & SEO are Essential</h2>
          <p>
            Digital marketing allows businesses to reach their audience where they spend most of their time — online. From Google searches to social media platforms, your customers are looking for solutions that you provide. By implementing effective SEO and marketing strategies, your business can rank higher in search results, attract qualified leads, and build brand awareness.
          </p>
          <p>
            SEO (Search Engine Optimization) ensures that your website content is structured and optimized to appear in search engine results. This improves organic traffic, credibility, and long-term growth, making it an essential component of any digital strategy.
          </p>
        </section>

        <section className="mb-5">
          <h2 className="mb-3">Our Digital Marketing Services</h2>
          <ul className="list-group list-group-flush">
            <li className="list-group-item">Search Engine Optimization (SEO) – On-page and Off-page</li>
            <li className="list-group-item">Pay-Per-Click (PPC) Advertising</li>
            <li className="list-group-item">Social Media Marketing (Facebook, Instagram, LinkedIn)</li>
            <li className="list-group-item">Content Marketing & Blogging</li>
            <li className="list-group-item">Email Marketing Campaigns</li>
            <li className="list-group-item">Website Analytics & Performance Tracking</li>
            <li className="list-group-item">Online Reputation Management</li>
          </ul>
        </section>

        <section className="mb-5">
          <h2 className="mb-3">Industries We Serve</h2>
          <p>
            Our digital marketing and SEO services cater to a wide range of industries, including startups, e-commerce, healthcare, education, hospitality, and professional services. We customize strategies based on industry trends, target audience behavior, and competitive analysis to ensure maximum impact.
          </p>
          <p>
            For e-commerce businesses, we focus on product SEO, paid advertising, and conversion optimization. For service-based companies, we enhance local SEO, content marketing, and lead generation campaigns to attract and retain customers effectively.
          </p>
        </section>

        <section className="mb-5">
          <h2 className="mb-3">Our SEO Process</h2>
          <p>
            Our SEO process begins with a detailed website audit to identify technical issues, content gaps, and keyword opportunities. We conduct in-depth research to target the right keywords that drive traffic and conversions.
          </p>
          <p>
            Next, we implement on-page SEO, optimizing meta tags, headings, URLs, and content. Off-page SEO, including link building, guest posting, and social signals, strengthens your website authority. We continuously monitor performance and adjust strategies to maintain top search rankings.
          </p>
        </section>

        <section className="mb-5">
          <h2 className="mb-3">Benefits of Choosing 100 Eyes Technologies</h2>
          <ul className="list-group list-group-flush">
            <li className="list-group-item">Expertise in digital marketing and SEO strategies</li>
            <li className="list-group-item">Customized campaigns for startups and SMEs</li>
            <li className="list-group-item">Measurable results and ROI-focused approach</li>
            <li className="list-group-item">Increased website traffic and lead generation</li>
            <li className="list-group-item">Enhanced brand visibility and online credibility</li>
            <li className="list-group-item">Ongoing support and analytics tracking</li>
          </ul>
        </section>

        <section className="mb-5">
          <h2 className="mb-3">Success Stories</h2>
          <p>
            We have helped numerous clients achieve top search rankings, increased website traffic, and significant growth in leads and sales. Our strategies are data-driven, ensuring that every marketing effort delivers measurable outcomes. Startups and SMEs benefit from targeted campaigns that are cost-effective yet highly impactful.
          </p>
          <p>
            From e-commerce product launches to service-based local businesses, our digital marketing campaigns have consistently delivered results that exceed expectations.
          </p>
        </section>

        <section className="mb-5">
          <h2 className="mb-3">Get Started Today</h2>
          <p>
            Boost your online presence with <strong>100 Eyes Technologies</strong> digital marketing and SEO services. Contact us today to discuss your business goals, and let’s create a customized strategy that attracts, engages, and converts your target audience effectively. With our expertise, your business will achieve higher visibility, increased traffic, and measurable growth in the digital space.
          </p>
        </section>
      </main>
    </>
  );
};

export default DigitalMarketingSEO;
